/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UserAnswerDto model module.
 * @module model/UserAnswerDto
 * @version v0
 */
class UserAnswerDto {
    /**
     * Constructs a new <code>UserAnswerDto</code>.
     * @alias module:model/UserAnswerDto
     */
    constructor() { 
        
        UserAnswerDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserAnswerDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserAnswerDto} obj Optional instance to populate.
     * @return {module:model/UserAnswerDto} The populated <code>UserAnswerDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserAnswerDto();

            if (data.hasOwnProperty('questionId')) {
                obj['questionId'] = ApiClient.convertToType(data['questionId'], 'Number');
            }
            if (data.hasOwnProperty('questionContent')) {
                obj['questionContent'] = ApiClient.convertToType(data['questionContent'], 'String');
            }
            if (data.hasOwnProperty('answerId')) {
                obj['answerId'] = ApiClient.convertToType(data['answerId'], 'Number');
            }
            if (data.hasOwnProperty('answerContent')) {
                obj['answerContent'] = ApiClient.convertToType(data['answerContent'], 'String');
            }
            if (data.hasOwnProperty('isCorrect')) {
                obj['isCorrect'] = ApiClient.convertToType(data['isCorrect'], 'Boolean');
            }
            if (data.hasOwnProperty('answeredAt')) {
                obj['answeredAt'] = ApiClient.convertToType(data['answeredAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserAnswerDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserAnswerDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['questionContent'] && !(typeof data['questionContent'] === 'string' || data['questionContent'] instanceof String)) {
            throw new Error("Expected the field `questionContent` to be a primitive type in the JSON string but got " + data['questionContent']);
        }
        // ensure the json data is a string
        if (data['answerContent'] && !(typeof data['answerContent'] === 'string' || data['answerContent'] instanceof String)) {
            throw new Error("Expected the field `answerContent` to be a primitive type in the JSON string but got " + data['answerContent']);
        }

        return true;
    }


}



/**
 * @member {Number} questionId
 */
UserAnswerDto.prototype['questionId'] = undefined;

/**
 * @member {String} questionContent
 */
UserAnswerDto.prototype['questionContent'] = undefined;

/**
 * @member {Number} answerId
 */
UserAnswerDto.prototype['answerId'] = undefined;

/**
 * @member {String} answerContent
 */
UserAnswerDto.prototype['answerContent'] = undefined;

/**
 * @member {Boolean} isCorrect
 */
UserAnswerDto.prototype['isCorrect'] = undefined;

/**
 * @member {Date} answeredAt
 */
UserAnswerDto.prototype['answeredAt'] = undefined;






export default UserAnswerDto;

